import { LazyAction, LazyModule } from 'owa-bundling';

import { completeLinkedInBind } from './utils/completeLinkedInBind';
import { isUnbound } from './selectors/isUnbound';
import { linkedInStore } from './store/store';
import { isBound } from './selectors/isBound';
import { isOptedOut } from './selectors/isOptedOut';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "LinkedIn" */ './lazyIndex'));

export let connectToLinkedInLazy = new LazyAction(lazyModule, m => m.connectToLinkedIn);

export let initializeBindStatusLazy = new LazyAction(lazyModule, m => m.initializeBindStatus);

if (typeof window !== 'undefined' && typeof window.Owa !== 'undefined') {
    window.Owa.completeLinkedInBind = completeLinkedInBind;
}

export { isUnbound, linkedInStore, isBound, isOptedOut };
